import { render, staticRenderFns } from "./FormsPreview.vue?vue&type=template&id=0a14a204"
import script from "./FormsPreview.vue?vue&type=script&lang=js"
export * from "./FormsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports